import { createSlice } from '@reduxjs/toolkit';
import { endOfWeek, formatISO, startOfWeek } from 'date-fns';
import { START_OF_WEEK } from '../../../constents';

export const calendarSlice = createSlice({
  name: 'calander',
  initialState: {
    calPeriodFilter: {
      name: 'week',
      startDate: formatISO(startOfWeek(new Date(), START_OF_WEEK)),
      endDate: formatISO(endOfWeek(new Date(), START_OF_WEEK)),
    },
  },
  reducers: {
    setCalPeriod: (state, action) => {
      state.calPeriodFilter = action.payload;
    },
  },
});

export const { setCalPeriod } = calendarSlice.actions;
export default calendarSlice.reducer;
